(function initSuoDiagnosisConfig(root) {
  "use strict";

  root.SUO_DIAG_CONFIG = {
    // Set this to the deployed Google Apps Script web app URL in production.
    logEndpoint: "https://script.google.com/macros/s/AKfycbzoFt1hjtdZKdCwnIC3CTHiJrr4dzQHwt7RfDMc-MkAr00oMU2LIcZ_yi-UVqyKG4ZSng/exec",
    // Which storefront this build is deployed on, so the shared log can separate
    // 自社(Shopify) and 楽天 results. Set "shopify" on the ec-life.suo.co.jp build
    // and "rakuten" on the Rakuten build. If left blank, the logger falls back to
    // detecting it from the page hostname.
    platform: "shopify"
  };
})(typeof window !== "undefined" ? window : globalThis);
